import FilledInputMixin from './filled-input-mixin.js';
import FilledFloatingLabelInputBaseMixin from './filled-floating-label-input-base-mixin.js';

function FilledFloatingLabelInputMixin(Base) {

  return class FilledFloatingLabelInput extends
    FilledInputMixin(
    FilledFloatingLabelInputBaseMixin(
      Base
  )) {}

}

export default FilledFloatingLabelInputMixin;
